import { on } from "events";
import { Check, View } from "lucide-react";
import { useState, useEffect } from "react";
import { CustomProperty } from "winslow-core";
import { AppCustomPropertyError } from "./AppCustomPropertyError";
import { NumberSettings } from "./customPropertyConfig";

type AppCustomPropertyNumberProps = {
    customProperty: CustomProperty;
    data: any;
    disabled: boolean;
    validate: boolean;
    onChange: (label: string, data: any) => void;
}

export const AppCustomPropertyNumber = ({customProperty, data, disabled, validate, onChange} : AppCustomPropertyNumberProps) => {

    const [value, setValue] = useState<string>(data as string || "");
    
    const settings = JSON.parse(customProperty.settings || "{}") as NumberSettings;

    // useEffect(() => {
    //     onChange(customProperty.label, value);
    // }, [value]);

    const validMinMax = value && !isNaN(Number(value)) && 
    (!settings.minNumOn || Number(value) >= settings.minNum) && (!settings.maxNumOn || Number(value) <= settings.maxNum);

    // console.log("[AppCustomPropertyNumber] need requirements flag: ", validate && !value && customProperty.required);
    // console.log("[AppCustomPropertyNumber] value: ", value);
    return (
        <div className="app-custom-property-number">
            {/* <div className="app-custom-property-label">
                {customProperty.label}
            </div> */}
            <div className="app-custom-property-value">
               
                <input 
                    type="number"
                    value={value}
                    disabled={disabled}
                    onChange={(event) => {
                        setValue(event.target.value);
                        onChange(customProperty.label, event.target.value);
                    }}
                />
                <AppCustomPropertyError 
                    flagRequired={validate && !value && customProperty.required}
                    flagError={validate && !validMinMax}
                    errorString={settings.minNumOn && settings.maxNumOn ? 
                        `Must be between ${settings.minNum} and ${settings.maxNum}` : 
                            settings.minNumOn ? `Must be greater than ${settings.minNum}` : 
                            `Must be less than ${settings.maxNum}`
                    }
                />
                {/* {validate && !value && customProperty.required &&
                    <div className="app-employee-record-error">
                        <Check size={16} color="red"/>
                    </div>
                } */}
            </div>
        </div>
    )
}
